import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { Customer } from '../models/identity.model';
import { HttpService } from '../../core/services/http.service';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class IdentityService {
	customer$: Observable<Customer>;

	constructor(private httpService: HttpService) {
		this.customer$ = this.httpService.get(environment.trovataApi + '/identity/customer').pipe(shareReplay(1));
	}
}
